import {
  ChangeEvent,
  ContentType,
  DSolutionsBadgeData,
} from '@bm-js/atlascloud-shared'
import MarginOptions from './MarginOptions'

type Props = {
  content: ContentType<DSolutionsBadgeData>
  setData: (e: ChangeEvent) => void
}

const AccordionEditor = ({ content, setData }: Props) => {
  return (
    <>
      <MarginOptions setData={setData} content={content} />
    </>
  )
}

export default AccordionEditor
